var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container index neirong"},[_vm._v(" 暂时不支持该浏览器，请更换其他浏览器进行访问，推荐搜狗浏览器"),_c('br')])}]

export { render, staticRenderFns }